/*
 * @Author: tkp
 * @Date: 2021-11-20 16:39:42
 */
// 导入axios
import axios from 'axios'
import { setting } from './setting';
const service = axios.create({
    baseURL: setting(),
    // 超时时间 单位是ms，这里设置了10s的超时时间
    timeout: 10 * 1000
})
// 2.请求拦截器
service.interceptors.request.use(config => {
    return config
}, error => {
    Promise.reject(error)
})
// 3.响应拦截器
service.interceptors.response.use(response => {
    return response.data
}, error => {
    return Promise.reject(error)
})

//4.导入文件
export default service


// WEBPACK FOOTER //
// ./src/utils/request.js